import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { Calendar, CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import * as moment from 'moment';
import { take, switchMap, first, finalize } from 'rxjs/operators';
import { ChatMessage } from 'src/app/class/chat-message/chat-message';
import { Patient } from 'src/app/class/patient/patient';
import { User } from 'src/app/class/user/user';
import { SessionService } from 'src/app/service/session.service';
import { Observable, from } from 'rxjs'; // 追加
import { map } from 'rxjs/operators'; // 追加
import * as firebase from 'firebase/app';
import { Image } from 'src/app/class/image/image';
import { AlertViewService } from 'src/app/services/alert-view.service';
import { Clinic, CLINIC_COLORS } from 'src/app/class/clinic/clinic';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { Event, OPTIONAL_EVENT_INPUTS_A, OPTIONAL_EVENT_INPUTS_B, OPTIONAL_EVENT_INPUTS_C } from 'src/app/class/event/event';
import { ImageUploadService } from 'src/app/services/image-upload.service';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import Swal from 'sweetalert2';
import * as process from 'process';
import { of } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { Location } from '@angular/common';
import { $ } from 'protractor';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-patient-detail',
  templateUrl: './patient-detail.component.html',
  styleUrls: ['./patient-detail.component.css']
})
export class PatientDetailComponent implements OnInit {



  public comments: Observable<ChatMessage[]>;
  public latestEvent: Observable<Event[]>;
  public events: Observable<Event[]>;
  eventsSubsc: any;
  public content = '';
  shiborikomiWord = "";

  public currentUser: User;

  public showSwitcher: boolean = false;

  public inventoryItems = [];

  public patient: Observable<Patient>;
  public patient_id: string
  public isCalendarView: boolean;

  related_members: User[] = [];
  related_clinics: any[] = [];
  public patients: Observable<Patient[]>;
  public clinics: Observable<Clinic[]>;


  defaultSelecctions: Observable<any>;
  clinicSelections: Observable<any>;

  eventEditMode = false;


  showDeleteButton = true;
  currentEventInfo: any;

  public repeatSetting: number = 0;

  imageSrc = [];

  form: FormGroup;
  inviteForm: FormGroup;
  submitted = false;
  disableEditRepeatSetting = false;


  calendarOptions: CalendarOptions = {

    initialView: 'dayGridMonth',
    eventTextColor: "#FFFFFF",
    dateClick: this.dateClick.bind(this), // bind is important!
    events: [

    ],
    editable: false,
    height: "auto",
    customButtons: {
      // myCustomButton: {
      //   text: '+予定を追加',
      //   click: this.addNewEvent.bind(this)
      // }
    },
    headerToolbar: {
      start: '',
      center: 'title',
      end: 'prev,next',
    },
    navLinks: true,
    locale: 'ja',

    dayCellContent: this.dayNumberText.bind(this),
    views: {

    },
    eventClick: this.eventClick.bind(this),



  };


  // references the #calendar in the template
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;




  dayNumberText(e) {
    e.dayNumberText = e.dayNumberText.replace('日', '');
  }





  public arrays = { ...OPTIONAL_EVENT_INPUTS_A };
  public Default持ち込み物品 = [];
  public Default実施物品 = [];

  public selected_areas = { ...OPTIONAL_EVENT_INPUTS_B };
  public input_areas = { ...OPTIONAL_EVENT_INPUTS_C };



  public newUserEmailAdress = "";


  private loading: any;

  private numOfComment = 10;



  constructor(
    private route: ActivatedRoute,
    private db: AngularFirestore,
    private session: SessionService,
    private location: Location,
    private router: Router,
    private alertViewService: AlertViewService,
    public platform: Platform,
    private imageUploadService: ImageUploadService,
    private formBuilder: FormBuilder,
    private storage: AngularFireStorage,
    public loadingController: LoadingController,
    public alertController: AlertController
  ) {

    this.loadingController.create({
      message: '読み込み中...',
      translucent: true
    });

    this.patient_id = (this.route.snapshot.paramMap.get('id'));

    this.showSwitcher = this.platform.width() < 980;




    this.session // 追加
      .sessionState
      .subscribe(data => {
        console.log(data);
        this.currentUser = data.user;

        this.patients = db
          .collection<Patient>('patients', ref => { return ref.where('members', 'array-contains', this.currentUser.uid); })
          .snapshotChanges()
          .pipe(
            map(actions => actions.map(action => {
              // 日付をセットしたコメントを返す
              const data = action.payload.doc.data() as Patient;
              const patientData = new Patient(
                data.patient_id,
                data.name,
                data.avatar,
                data.members,
                data.clinic_id,
                data.isboardroom,
                data.disease_name,
                data.birthday,
                data.unReadMembers
              );
              if (environment.debug) {
                console.log(patientData);
              }
              patientData.setCommentRef(db.collection('patients').doc(data.patient_id).collection<ChatMessage>('comments', ref => { return ref.orderBy('time', 'asc').limit(1); }));

              if (!data.isboardroom) {
                const partner_id = data.members.filter(n => n !== this.currentUser.uid)[0];
                patientData.setMemberRef(db.doc<User>('users/' + partner_id));
              }



              return patientData;
            })));

        this.defaultSelecctions = db.doc<any>('default-selections/event').valueChanges();
        this.clinicSelections = db.doc<any>('clinics/' + this.currentUser.clinic_id + '/selections/event').valueChanges();


        this.patient = this.db
          .collection('patients')
          .doc(this.patient_id)
          .valueChanges()
          .pipe(

            switchMap((patient: Patient) => {

              const patientData = new Patient(
                patient.patient_id,
                patient.name,
                patient.avatar,
                patient.members,
                patient.clinic_id,
                patient.isboardroom,
                patient.disease_name,
                patient.birthday,
                patient.unReadMembers
              );

              var canAccessableUser = false;
              patientData.members.forEach((member, index) => {
                patientData.convertMembersToRef(db.doc<User>('users/' + member));
                if (member === this.currentUser.uid) {
                  canAccessableUser = true;
                }
              })


              this.loadRelatedClinics(patientData.membersRef);


              if (!canAccessableUser) {

                this.router.navigate(['/page-not-found']);
              }

              patientData.setClinicRef(db.doc<Clinic>('clinics/' + patient.clinic_id));
              patientData.setRawData(patient);

              if (patientData) {
                return of(patientData);
              } else {
                return of(null);
              }
            })
          );

      });









    this.comments = this.getObservableComment(10);

    this.latestEvent = db.collection('patients').doc(this.patient_id)
      .collection<Event>('events', ref => {
        return ref.where('date', '<', Date.now()).orderBy('date', 'desc').limit(1);
      })
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(action => {
          // 日付をセットしたコメントを返す
          const data = action.payload.doc.data() as Event;
          // console.log(data);
          return data;
        })));



    this.events = db.collection('patients').doc(this.patient_id)
      .collection<Event>('events', ref => { return ref.orderBy('date', 'asc'); })
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(action => {

          // 日付をセットしたコメントを返す
          const data = action.payload.doc.data() as Event;
          // console.log(data);
          return data;
        })))

    this.eventsSubsc = this.events.subscribe((events) => {
      if (environment.debug) {
        console.log(events);
      }

      this.getOptions(events);

    })


    this.clinics = this.db
      .collection<Clinic>('clinics')
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(action => {
          // 日付をセットしたコメントを返す
          const data = action.payload.doc.data();
          const clinicData = new Clinic(
            data.name,
            data.event_color
          );
          clinicData.setId(action.payload.doc.id)
          clinicData.setCreatedByVisitorList(data["createdByVisitorList"])
          if (environment.debug) {
            console.log(clinicData);
          }
          return clinicData;
        })));




    this.isCalendarView = true;
  }

  ngOnDestroy() {
    this.closeModal();
  }

  releaseNumOfComment() {
    this.comments = this.getObservableComment(10000);
  }

  getObservableComment(num) {
    return this.db.collection('patients').doc(this.patient_id)
      .collection<ChatMessage>('comments', ref => {
        return ref.orderBy('time', 'desc').limit(num);
      })
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(action => {
          // 日付をセットしたコメントを返す
          const data = action.payload.doc.data() as ChatMessage;
          const key = action.payload.doc.id;
          const commentData = new ChatMessage(data.sender, data.content, data.read, data.image, data.time);
          commentData.setKey(key)

          commentData.read.forEach((uid, index) => {
            if (uid !== "") {
              commentData.setReadersRef(this.db.doc<User>('users/' + uid));
            }

          })


          return commentData;
        })));
  }


  pasteLatestVital(latestEvent) {

    var string = "" + "\n" +
      "◇バイタルサイン" + "\n" +
      "血圧:" + (latestEvent.optionalInputs.blood_pressure_high ? latestEvent.optionalInputs.blood_pressure_high : "[未入力]") + "/" + (latestEvent.optionalInputs.blood_pressure_low ? latestEvent.optionalInputs.blood_pressure_low : "[未入力]") + "mmHg\n" +
      "脈拍数:" + (latestEvent.optionalInputs.pulse ? latestEvent.optionalInputs.pulse : "[未入力]") + "bpm\n" +
      "SpO2:" + (latestEvent.optionalInputs.SPO2 ? latestEvent.optionalInputs.SPO2 : "[未入力]") + "%\n" +
      "体温:" + (latestEvent.optionalInputs.Temp ? latestEvent.optionalInputs.Temp : "[未入力]") + "℃\n" +
      "体重:" + (latestEvent.optionalInputs.Weight ? latestEvent.optionalInputs.Weight : "[未入力]") + "kg\n" +
      "";

    this.content = this.content + '\n' + string;
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄にコピーしました',
      showConfirmButton: false,
      timer: 1000
    })

  }

  getFormatedDay(str) {

    return this.formatDate(new Date(str), 'yyyy/MM/dd HH:mm');
  }

  formatDate(date, format) {
    format = format.replace(/yyyy/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
  };


  getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }





  inviteNewUser() {
    if (this.inviteForm.invalid) {
      this.alertViewService.showErrorAlert("無効なメールアドレスです");
      return;
    }

    this.db.collection<User>('users', ref => { return ref.where('email', '==', this.inviteForm.value.email) })
      .get().toPromise().then((snapshot) => {
        this.alertViewService.showYesNoInviteAlertAdd(this.inviteForm.value.email).then(ret => {
          if (ret) {
            if (snapshot.empty) {

              this.db.collection('pending-invite').doc(this.newUserEmailAdress)
                .set({
                  email: this.newUserEmailAdress,
                  joined: false,
                  patient: this.patient_id
                });

              this.newUserEmailAdress = "";
            } else {

              snapshot.forEach(doc => {
                this.inviteMemberToPatientNoAlert(doc.data())
              });

            }
          }
        })
      })
  }

  radioSelected(id) {

    this.repeatSetting = id;
    if (id == 2) {
      this.showMonthlyAlert();

    }
  }


  selectedWeekDays = {};
  async showMonthlyAlert() {
    const { value: formValues } = await Swal.fire({
      title: 'リピート設定',
      html:
        '<div class="card mb-3 overflow-hidden"><div class="card-body bg-light"><div style="display: inline-block;"><h6 class="fw-bold">週設定</h6><div class="ps-2"><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekSettings1" checked="checked"><label class="form-check-label mb-0" for="weekSettings1">第１</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekSettings2" checked="checked"><label class="form-check-label mb-0" for="weekSettings2">第２</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekSettings3"><label class="form-check-label mb-0" for="weekSettings3">第３</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekSettings4"><label class="form-check-label mb-0" for="weekSettings4">第４</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekSettings5"><label class="form-check-label mb-0" for="weekSettings5">第５</label></div><div class="form-check mb-0 lh-1" style="opacity: 0;"><input class="form-check-input" type="checkbox" id="weekSettings6"><label class="form-check-label mb-0" for="weekSettings6">第５</label></div><div class="form-check mb-0 lh-1" style="opacity: 0;"><input class="form-check-input" type="checkbox" id="weekSettings7"><label class="form-check-label mb-0" for="weekSettings7">第５</label></div></div></div><div style="display: inline-block;"><h6 class="mt-2 fw-bold">曜日設定</h6><div class="ps-2"><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings1" checked="checked"><label class="form-check-label mb-0" for="weekDaySettings1">月曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings2" checked="checked"><label class="form-check-label mb-0" for="weekDaySettings2">火曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings3"><label class="form-check-label mb-0" for="weekDaySettings3">水曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings4"><label class="form-check-label mb-0" for="weekDaySettings4">木曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings5"><label class="form-check-label mb-0" for="weekDaySettings5">金曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings6"><label class="form-check-label mb-0" for="weekDaySettings6">土曜</label></div><div class="form-check mb-0 lh-1"><input class="form-check-input" type="checkbox" id="weekDaySettings7"><label class="form-check-label mb-0" for="weekDaySettings7">日曜</label></div></div></div></div></div>',

      focusConfirm: false,
      preConfirm: () => {
        return [
          document.getElementById('weekSettings1')["checked"],
          document.getElementById('weekSettings2')["checked"],
          document.getElementById('weekSettings3')["checked"],
          document.getElementById('weekSettings4')["checked"],
          document.getElementById('weekSettings5')["checked"],
          document.getElementById('weekSettings6')["checked"],
          document.getElementById('weekSettings7')["checked"],
          document.getElementById('weekDaySettings1')["checked"],
          document.getElementById('weekDaySettings2')["checked"],
          document.getElementById('weekDaySettings3')["checked"],
          document.getElementById('weekDaySettings4')["checked"],
          document.getElementById('weekDaySettings5')["checked"],
          document.getElementById('weekDaySettings6')["checked"],
          document.getElementById('weekDaySettings7')["checked"]
        ]
      }
    })

    if (formValues) {
      this.selectedWeekDays = formValues;
    }
  }

  getSelectedWeekDayByMonth(selectedWeekDays, numOfWeekDay, numOfMonth, numOfYear) {
    var d = new Date();
    d.setFullYear(numOfYear);
    d.setMonth(numOfMonth);

    var month = d.getMonth();
    var mondays = [];

    d.setDate(1);

    // Get the first Mondays in the month
    while (d.getDay() !== numOfWeekDay) {
      d.setDate(d.getDate() + 1);
    }

    // Get all the other Mondays in the month
    while (d.getMonth() === month) {
      mondays.push(new Date(d.getTime()));
      d.setDate(d.getDate() + 7);
    }


    var returnMondays = [];

    for (var i = 0; i < 5; i++) {
      if (selectedWeekDays[i] && (mondays[i] != undefined)) {
        returnMondays.push(mondays[i]);
      }
    }

    return returnMondays;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        clinicId: ['', [Validators.required]],
        startTime: ['', [Validators.required]],
        endTime: [''],
        blood_pressure_high: [''],
        blood_pressure_low: [''],
        pulse: [''],
        SPO2: [''],
        Temp: [''],
        Weight: [''],
        description: ['']
      }
    );

    this.inviteForm = this.formBuilder.group(
      {
        email: ["", [Validators.required, Validators.email]],
      }
    );


    const button = document.querySelector(".invitepeople .dropdown-menu");

    button.addEventListener('click', event => {
      event.stopPropagation();
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  get invitef(): { [key: string]: AbstractControl } {
    return this.inviteForm.controls;
  }


  getOptions(events) {


    var newEvents = [];

    events.forEach((ev) => {
      newEvents.push(ev);
    });

    this.clinics.pipe(first()).subscribe(clinics => {
      newEvents.forEach(event => {
        event["title"] = this.getClinicName(clinics, event.clinicId);
        event["color"] = this.getClinicColor(clinics, event.clinicId);
        if (event["color"] === "#EEEEEE") {
          event["textColor"] = "#555555";
        }

        if (event["finalComfirmed"]) {
          event["classNames"] = ["finishedMK"];
        }
      })



      this.calendarOptions.events = [];
      this.calendarOptions.events = newEvents.concat();

      this.dismissLoader();
    });


  }


  showNewClinicAlert(defaultValue) {

    var createdId = "";
    Swal.fire({
      title: '事業所名を入力',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'OK',
      showLoaderOnConfirm: true,
      confirmButtonColor: '#28A745',
      cancelButtonText: "キャンセル",


      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value.length < 3) {
            resolve('正しいクリニック名を入力してください')

          } else {

            const id = this.db.createId();
            this.db.collection("clinics").doc(id).set({
              event_color: CLINIC_COLORS[Math.floor(Math.random() * CLINIC_COLORS.length)],
              id: id,
              name: value,
              createdByVisitorList: true
            });
            this.db.collection("clinics").doc(id).collection("selections").doc("patient").set({

            });
            this.db.collection("clinics").doc(id).collection("selections").doc("event").set({

            });


            createdId = id
            resolve(null);
          }
        })
      }

    }).then((result) => {
      if (result.isConfirmed) {
        this.form.controls["clinicId"].setValue(createdId);
      } else {
        this.form.controls["clinicId"].setValue("");

      }
    })
  }

  onChangeInput(evt) {
    const file: File = evt.target.files[0];

    // ファイル名を取得
    const fileName = file.name;

    // 保存先,ファイル名を指定
    const filePath = 'upload_files/' + fileName;
    const fileRef = this.storage.ref(filePath);

    this.storage.upload(filePath, file).snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().pipe(first()).subscribe(url => {
          if (url) {
            this.imageSrc.push({
              name: fileName,
              url: url
            });
            console.log(url);
          }
        });
      })
    ).subscribe()
  }





  addNewEvent(arg) {
    this.currentEventInfo = arg;
    this.resetModalValues();
    this.showDeleteButton = false;
    this.eventEditMode = true;


    // 在宅在庫情報の取得
    this.events.pipe(first()).subscribe((events) => {

      // Create Inventory Info
      events.forEach((event, index) => {
        if (index > 0) {
          event["optionalInputs"]['在宅在庫'] = { ...(events[index - 1]["optionalInputs"]['在宅在庫']) };
        } else {
          event["optionalInputs"]['在宅在庫'] = {};
        }

        event["optionalInputs"]['持ち込み物品'].forEach((item) => {
          event["optionalInputs"]['在宅在庫'][item.name] =
            (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) + item.num;
        });
        if (environment.debug) {
          console.log(events);
        }

        event["optionalInputs"]['実施物品'].forEach((item) => {
          event["optionalInputs"]['在宅在庫'][item.name] =
            (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) - item.num;
        });

        if (environment.debug) {
          console.log(event)
        }
      })

      let event;
      for (let i = 0; i < events.length; i++) {
        {
          if (events[i]["date"] > Date.parse(this.currentEventInfo.dateStr)) {
            console.log(events[i - 1]["date"]);
            event = events[i - 1];
            break;
          }
        }
      }

      if (event) {
        this.arrays["在宅在庫"] = event["optionalInputs"]["在宅在庫"];
      }

      document.getElementById("addschedule").click();
    })

  }

  onStartTimeChange(value) {
    console.log(value);
    this.form.controls["endTime"].setValue(value.split(":")[0] + ":30");

  }

  dateClick(arg) {
    this.loadingController.create({
      message: '読み込み中...',
      translucent: true
    }).then((response) => {
      response.present();

      this.currentEventInfo = arg;
      this.resetModalValues();
      this.showDeleteButton = false;
      this.eventEditMode = true;

      // Set Values
      this.form.controls["startTime"].setValue(arg.dateStr + "T00:00");

      // 在宅在庫情報の取得
      this.events.pipe(first()).subscribe((events) => {

        // Create Inventory Info
        events.forEach((event, index) => {
          if (index > 0) {
            event["optionalInputs"]['在宅在庫'] = { ...(events[index - 1]["optionalInputs"]['在宅在庫']) };
          } else {
            event["optionalInputs"]['在宅在庫'] = {};
          }

          event["optionalInputs"]['持ち込み物品'].forEach((item) => {
            event["optionalInputs"]['在宅在庫'][item.name] =
              (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) + item.num;
          });

          console.log(events);

          event["optionalInputs"]['実施物品'].forEach((item) => {
            event["optionalInputs"]['在宅在庫'][item.name] =
              (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) - item.num;
          });

          console.log(event)
        })

        let event;
        for (let i = 0; i < events.length; i++) {
          {
            if (events[i]["date"] > Date.parse(this.currentEventInfo.dateStr)) {
              if (i == 0) {
                break;
              } else {
                console.log(events[i - 1]["date"]);
                event = events[i - 1];
                break;
              }

            }
          }
        }

        if (event) {
          this.arrays["在宅在庫"] = event["optionalInputs"]["在宅在庫"];
        }

        document.getElementById("addschedule").click();
        this.dismissLoader();
      })
    })

  }

  isRelatedClinic(clinic) {
    if (clinic.name.length == 0) return false;
    if (clinic.name === "その他") return true;

    if (this.related_clinics.find((cid) => clinic.id === cid) == undefined) {
      return false;
    } else {
      return true;
    }

  }

  dismissLoader() {
    this.loadingController.dismiss().then((response) => {
      console.log('Loader closed!', response);
    }).catch((err) => {
      console.log('Error occured : ', err);
    });
  }

  eventClick(arg) {
    this.loadingController.create({
      message: '読み込み中...',
      translucent: true
    }).then((response) => {
      response.present();

      this.resetModalValues();
      this.currentEventInfo = arg;
      this.showDeleteButton = true;
      this.eventEditMode = false;


      this.events.pipe(first()).subscribe((events) => {

        // Create Inventory Info
        events.forEach((event, index) => {
          if (index > 0) {
            event["optionalInputs"]['在宅在庫'] = { ...(events[index - 1]["optionalInputs"]['在宅在庫']) };
          } else {
            event["optionalInputs"]['在宅在庫'] = {};
          }

          event["optionalInputs"]['持ち込み物品'].forEach((item) => {
            event["optionalInputs"]['在宅在庫'][item.name] =
              (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) + item.num;
          });

          console.log(events);

          event["optionalInputs"]['実施物品'].forEach((item) => {
            event["optionalInputs"]['在宅在庫'][item.name] =
              (event["optionalInputs"]['在宅在庫'][item.name] ? event["optionalInputs"]['在宅在庫'][item.name] : 0) - item.num;
          });

          console.log(event)
        })


        const event: Event = events.find((event) => {
          return event.id === arg.event.id;
        });



        // Set Values
        this.repeatSetting = event['repeat_setting']; // Not allow 1 and 2. Please Use 0 only...
        this.form = this.formBuilder.group(
          {
            id: [event["id"]], // *******Editing Only*******
            repeat_id: [event["repeat_id"]],// *******Editing Only*******

            clinicId: [event["clinicId"], [Validators.required]],
            startTime: [event["optionalInputs"]["startTime"], [Validators.required]],
            endTime: [event["optionalInputs"]["endTime"]],
            blood_pressure_high: [event["optionalInputs"]["blood_pressure_high"]],
            blood_pressure_low: [event["optionalInputs"]["blood_pressure_low"]],
            pulse: [event["optionalInputs"]["pulse"]],
            SPO2: [event["optionalInputs"]["SPO2"]],
            Temp: [event["optionalInputs"]["Temp"]],
            Weight: [event["optionalInputs"]["Weight"]],
            description: [event["optionalInputs"]["description"]]
          }
        );


        this.arrays.処置内容 = event["optionalInputs"]["処置内容"].concat();
        this.arrays.持ち込み物品 = event["optionalInputs"]["持ち込み物品"].concat();
        this.Default持ち込み物品 = [];
        this.arrays.持ち込み物品.forEach((element) => { // 変更前の持ち込み物品数量
          this.Default持ち込み物品.push({ name: element["name"], num: element["num"] })
        });

        this.arrays.実施物品 = event["optionalInputs"]["実施物品"].concat();
        this.Default実施物品 = [];
        this.arrays.実施物品.forEach((element) => { // 変更前の実施物品数量
          this.Default実施物品.push({ name: element["name"], num: element["num"] })
        });

        this.arrays["在宅在庫"] = event["optionalInputs"]["在宅在庫"];



        // 在宅在庫を 実施物品へ反映
        for (const [key, value] of Object.entries(this.arrays["在宅在庫"])) {

          if (this.arrays.実施物品.find((item) => {
            return key === item["name"]
          })) {
            // do nothing...
          } else {
            if (value > 0) {
              this.arrays.実施物品.push({ name: key, num: 0 })
            }
          }
        };



        this.disableEditRepeatSetting = true;
        this.dismissLoader();
        document.getElementById("addschedule").click();

      })



    });



  }


  copyToClipboard(vale) {

    navigator.clipboard.writeText(vale);
  }


  resetModalValues() {

    this.submitted = false;
    this.repeatSetting = 0;
    this.arrays = { ...OPTIONAL_EVENT_INPUTS_A };
    this.arrays.処置内容 = [];
    this.arrays.実施物品 = [];
    this.arrays.持ち込み物品 = [];
    this.selected_areas = { ...OPTIONAL_EVENT_INPUTS_B };
    this.input_areas = { ...OPTIONAL_EVENT_INPUTS_C };
    this.disableEditRepeatSetting = false;

    this.form = this.formBuilder.group(
      {
        clinicId: ["", [Validators.required]],
        startTime: ['', [Validators.required]],
        endTime: [''],
        blood_pressure_high: [''],
        blood_pressure_low: [''],
        pulse: [''],
        SPO2: [''],
        Temp: [''],
        Weight: [''],
        description: ['']
      }
    );

  }

  // 新しいコメントを追加
  addComment(e: Event, comment: string, patient: Patient) {

    if (comment || this.imageSrc.length) {

      this.db.collection('patients').doc(this.patient_id)
        .update({
          unReadMembers: patient.members.filter(member => { return member !== this.currentUser.uid }),
          updated: +moment()
        }).then(() => {
          this.db.collection('patients').doc(this.patient_id)
            .collection('comments')
            .add(new ChatMessage(this.currentUser, comment, [this.currentUser.uid], this.imageSrc, +moment()).deserialize()); // 更新
          this.content = '';
          this.imageSrc = [];
        });


    }
  }

  deleteMessage(comment) {

    this.alertViewService.showYesNoAlertDelete("掲示板のメッセージ").then((ret) => {
      this.db.collection('patients').doc(this.patient_id)
        .collection('comments').doc(comment['key']).delete();
    })

  }

  isFeatureDate(selectedDate) {
    // console.log(selectedDate);

    return (new Date() < new Date(selectedDate))
  }

  loadRelatedClinics(members) {

    this.related_clinics = [];

    members.forEach(member => {
      var susc = member.pipe(first()).subscribe((mem) => {
        if (mem != undefined) {
          this.related_clinics.push(mem.clinic_id);
        }

        susc.unsubscribe();
      })


    });

    console.log(this.related_clinics);


  }


  showFile(url) {

    window.open(url, '_blank', 'location=yes');
  }

  pasteInventory() {
    var string = "" + "" +
      "◇在宅在庫" + "";

    Object.keys(this.arrays['在宅在庫']).map(key => {
      string = string + '\n' + key + "（数量" + this.arrays['在宅在庫'][key] + "点）"
    });

    string = string + "\n" +
      "";

    this.copyToClipboard(string);

    this.content = this.content + "\n" + string;

    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄とクリップボードにコピーしました',
      showConfirmButton: false,
      timer: 1000
    })


  }

  pasteToClipboard(title, detail) {


    if (title === "連絡先") {
      var string = "" + "" +
        "◇" + title + "\n";

      detail.forEach(element => {
        string = string + element.name + "(TEL:" + element.num + ")" + "\n"
      });

      string = string + "";
    } else if (title === "かかりつけ薬局") {
      var string = "" + "" +
        "◇" + title + "\n";

      detail.forEach(element => {
        string = string + element.name + "(TEL:" + element.num + "/FAX:" + element.fax + ")" + "\n"
      });

      string = string + "";
    } else if (title === "持ち込み物品") {
      var string = "" + "" +
        "◇" + title + "\n";

      detail.forEach(element => {
        string = string + element.name + "(数量:" + element.num + ")" + "\n"
      });

      string = string + "";
    } else if (title === "実施物品") {
      var string = "" + "" +
        "◇" + title + "\n";

      detail.forEach(element => {
        string = string + element.name + "(数量:" + element.num + ")" + "\n"
      });

      string = string + "";
    } else {
      var string = "" + "" +
        "◇" + title + "\n" +
        detail + "\n" +
        "";
    }





    this.copyToClipboard(string);
    this.content = this.content + '\n' + string;
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄とクリップボードにコピーしました',
      showConfirmButton: false,
      timer: 1000
    })
  }

  pasteToClipboardFotADL(patient) {
    /*
      <br>
                                                        {{(patient | async)?.rawData["入浴"]}}<br><br>
                                                        【食事】<br>
                                                        {{(patient | async)?.rawData["食事"]}}<br><br>
                                                        【内服】<br>
                                                        {{(patient | async)?.rawData["内服"]}}<br><br>
                                                        【排泄】<br>
                                                        {{(patient | async)?.rawData["排泄"]}}<br><br>
                                                        【移動】<br>
                                                        {{(patient | async)?.rawData["移動"]}}<br><br>
                                                        【利き腕】<br>
                                                        {{(patient | async)?.rawData["利き腕"]}}<br><br>
                                                        【身長】<br>
                                                        {{(patient | async)?.rawData["身長"]}}cm<br><br>
                                                        【麻痺・拘縮の有無】<br>
                                                        {{(patient | async)?.rawData["拘縮選択"]}}<br>
                                                        {{(patient | async)?.rawData["拘縮入力"]}}<br><br>
                                                        【意思疎通：認知機能低下の有無】<br>
                                                        {{(patient | async)?.rawData["認知機能選択"]}}<br>
                                                        {{(patient | async)?.rawData["認知機能入力"]}}<br><br>
                                                        【意思疎通：難聴の有無】<br>
                                                        {{(patient | async)?.rawData["難聴選択"]}}<br>
                                                        {{(patient | async)?.rawData["難聴入力"]}}<br><br>
                                                        【視覚障害の有無】<br>
                                                        {{(patient | async)?.rawData["視覚障害選択"]}}<br>
                                                        {{(patient | async)?.rawData["視覚障害入力"]}}<br><br>
      */


    var string = "" + "" +
      "◇初診時ADL" + "\n" +
      "【入浴】:\n" + patient.rawData["入浴"] + "\n" +
      "【食事】:\n" + patient.rawData["食事"] + "\n" +
      "【内服】:\n" + patient.rawData["内服"] + "\n" +
      "【排泄】:\n" + patient.rawData["排泄"] + "\n" +
      "【移動】:\n" + patient.rawData["移動"] + "\n" +
      "【利き腕】:\n" + patient.rawData["利き腕"] + "\n" +
      "【身長】:\n" + patient.rawData["身長"] + "\n" +
      "【麻痺・拘縮の有無】:\n" + patient.rawData["拘縮選択"] + "\n" + patient.rawData["拘縮入力"] + "\n" +
      "【意思疎通：認知機能低下の有無】:\n" + patient.rawData["認知機能選択"] + "\n" + patient.rawData["認知機能入力"] + "\n" +
      "【意思疎通：難聴の有無】:\n" + patient.rawData["難聴選択"] + "\n" + patient.rawData["難聴入力"] + "\n" +
      "【視覚障害の有無】:\n" + patient.rawData["視覚障害選択"] + "\n" + patient.rawData["視覚障害入力"] + "\n" +
      "";

    this.copyToClipboard(string);
    this.content = this.content + '\n' + string;
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄とクリップボードにコピーしました',
      showConfirmButton: false,
      timer: 1000
    })
  }

  pasteVitalSign() {


    var string = "" + "" +
      "◇バイタルサイン" + "\n" +
      "血圧:" + (this.form.value.blood_pressure_high ? this.form.value.blood_pressure_high : "[未入力]") + "/" + (this.form.value.blood_pressure_low ? this.form.value.blood_pressure_low : "[未入力]") + "mmHg\n" +
      "脈拍数:" + (this.form.value.pulse ? this.form.value.pulse : "[未入力]") + "bpm\n" +
      "SpO2:" + (this.form.value.SPO2 ? this.form.value.SPO2 : "[未入力]") + "%\n" +
      "体温:" + (this.form.value.Temp ? this.form.value.Temp : "[未入力]") + "℃\n" +
      "体重:" + (this.form.value.Weight ? this.form.value.Weight : "[未入力]") + "kg\n" +
      "";

    this.copyToClipboard(string);
    this.content = this.content + '\n' + string;
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄とクリップボードにコピーしました',
      showConfirmButton: false,
      timer: 1000
    })

  }

  pasteTreatInfo() {
    var string = "" + "\n" +
      "◇診療内容" + "\n" +
      (this.form.value.description ? this.form.value.description : "[未入力]") + "\n" +
      "";

    this.copyToClipboard(string);

    this.content = this.content + '\n' + string;

    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: '投稿欄とクリップボードにコピーしました',
      showConfirmButton: false,
      timer: 1000
    })
  }

  pasteAllInfo() {
    var string = "";



    return string;
  }



  read(key) {

    if (this.currentUser.uid !== "") {
      this.db.collection('patients').doc(this.patient_id)
        .collection('comments').doc(key)
        .update({
          read: firebase.default.firestore.FieldValue.arrayUnion(this.currentUser.uid)
        });


      this.hasReadAllMessages().then((ret) => {
        if (ret) {
          this.db.collection('patients').doc(this.patient_id)
            .update({
              unReadMembers: firebase.default.firestore.FieldValue.arrayRemove(this.currentUser.uid)
            });
        }
      })
    }
  }

  readAll() {
    if (this.currentUser.uid !== "") {
      this.alertViewService.showYesNoInviteReadAll().then((ret) => {
        var batch = this.db.firestore.batch();

        this.getObservableComment(10000).pipe(first()).subscribe((comments) => {
          const ret = comments.filter((comment => {
            return !comment.read.includes(this.currentUser.uid)
          }));

          ret.forEach((doc) => {
            var docRef = this.db.firestore.collection('patients').doc(this.patient_id).collection('comments').doc(doc.key); //automatically generate unique id
            batch.update(docRef, {
              read: firebase.default.firestore.FieldValue.arrayUnion(this.currentUser.uid)
            });
          });

          batch.commit();
        });



        this.db.collection('patients').doc(this.patient_id)
          .update({
            unReadMembers: firebase.default.firestore.FieldValue.arrayRemove(this.currentUser.uid)
          });

      });
    }
  }

  hasReadAllMessages() {
    return new Promise((resolve) => {
      this.getObservableComment(10000).pipe(first()).subscribe((comments) => {
        const ret = comments.find((comment => {
          return !comment.read.includes(this.currentUser.uid)
        }));
        resolve(ret == undefined ? true : false);
      })
    })
  }



  countReader(readers, uid) {
    return readers.filter(function (x) { return x === uid }).length;
  }

  closeModal() {
    document.getElementById("addEventModal").click();
  }



  addingNewMemberNow = false;
  inviteMemberToPatient(member: User, event) {
    this.addingNewMemberNow = true;
    this.db.collection("patients").doc(this.patient_id).update({
      members: firebase.default.firestore.FieldValue.arrayUnion(member.uid),
      updated: +moment()
    }).then(() => {
      this.alertViewService.notifyPromise(member.name + "さんを招待しました").then(() => {

        this.patient.pipe(first()).subscribe((patient) => {

          patient.members.forEach((memberData) => {
            this.related_members = this.related_members.filter((mem) => {
              return mem.uid !== memberData;
            }).concat();
          })
          this.addingNewMemberNow = false;
        })

      })
    });



    event.stopPropagation();
  }

  inviteMemberToPatientNoAlert(member: User) {
    this.db.collection("patients").doc(this.patient_id).update({
      members: firebase.default.firestore.FieldValue.arrayUnion(member.uid),
      updated: +moment()
    }).then(() => {
      // this.alertViewService.notify(member.name + "さんを招待しました");
    });


    this.related_members = this.related_members.filter((mem) => {
      return mem.uid !== member.uid;
    }).concat();
  }

  removeMember(member: User) {
    this.db.collection("patients").doc(this.patient_id).update({
      members: firebase.default.firestore.FieldValue.arrayRemove(member.uid),
      unReadMembers: firebase.default.firestore.FieldValue.arrayRemove(member.uid)
    }).then(() => {
      this.alertViewService.notify(member.name + "さんをメンバーから外しました");
    });
  }


  loadInvites(patient) {

    var members_id = [];
    this.related_members = [];

    // 同じ事業所の同僚を検索
    this.db.collection<User>('users', ref => { return ref.where('clinic_id', '==', this.currentUser.clinic_id) })
      .get().toPromise().then((snapshot) => {

        snapshot.forEach(doc => {
          if (environment.debug) {
            console.log(doc.id, '=>', doc.data());
          }
          const data = doc.data() as User;
          const userData = new User(
            data.uid,
            data.name,
            data.avatar,
            data.email,
            data.tel,
            data.clinic_id,
            data.occupation,
            data.summary
          );

          members_id.push(userData.uid);

        });


        // 患者さんに関係する医療従事者を検索する
        this.patients.pipe().subscribe((patients) => {
          if (environment.debug) {
            console.log(patients)
          }
          patients.forEach((patient) => {
            patient.members.forEach((id) => {
              members_id.push(id);
            })
          })

          // member_idの重複削除
          members_id = [...new Set(members_id)];




          // 追加済Userをmember_idから削除
          patient.members.forEach((id) => {
            members_id = members_id.filter(member => {
              return member !== id;
            })
          })



          // 自分を除外
          members_id = members_id.filter(member => {
            return member !== this.currentUser.uid;
          })

          members_id.forEach((id) => {
            this.db.collection<User>('users').doc(id)
              .get().toPromise().then((doc) => {
                const data = doc.data() as User;
                if (data) {


                  const userData = new User(
                    data.uid,
                    data.name,
                    data.avatar,
                    data.email,
                    data.tel,
                    data.clinic_id,
                    data.occupation,
                    data.summary
                  );
                  if (this.related_members.filter((item) => userData.uid === item.uid).length) {

                  } else {
                    this.related_members.push(userData);
                  }

                  patients.forEach(patient => {

                  })
                }
              });
          })



        });
      })
  }


  getClinicName(clinics, id) {
    if (id == undefined) return "";
    if (clinics != null) {
      return clinics.find(item => item.id === id) ? clinics.find(item => item.id === id).name : "";
    };
  }

  getClinicColor(clinics, id) {
    if (id == undefined) return "";

    if (clinics != null) {
      const ret = clinics.find(item => item.id === id);

      if (ret.createdByVisitorList) {
        return "#EEEEEE"
      }

      return ret ? ret.event_color : "";
    };
  }


  zaitakuZaikoUpdated = [];
  mergeZaikoAndMochikomi() {


    let keys = [];
    if (!this.isEmpty(this.arrays["在宅在庫"])) {
      for (let key in this.arrays["在宅在庫"]) {
        keys.push({ name: key, num: this.arrays["在宅在庫"][key] });
      }
    }


    const isNewEvent = !this.showDeleteButton;
    var data = keys.concat();
    if (isNewEvent) {
      data = this.arrays.持ち込み物品.concat(data);
    } else {

      let defaults持ち込み物品 = [];
      this.Default持ち込み物品.forEach(element => {
        defaults持ち込み物品.push({ name: element.name, num: element.num * (-1) })
      });

      data = this.arrays.持ち込み物品.concat(data);
      data = defaults持ち込み物品.concat(data);


      let defaults実施物品 = [];
      this.Default実施物品.forEach(element => {
        defaults実施物品.push({ name: element.name, num: element.num * (1) })
      });


      data = defaults実施物品.concat(data);
    }

    var r = {};
    data.forEach(function (o) {
      r[o["name"]] = (r[o["name"]] || 0) + o["num"];
    })

    var result = Object.keys(r).map(function (k) {
      return { name: k, num: r[k] }
    });


    this.arrays["実施物品"].forEach((item) => {
      result.forEach((zaiko, index) => {
        if (zaiko.name === item["name"]) {
          result[index].num = zaiko.num - item["num"];
        }
      })
    });


    if (!this.compareArray(result, this.zaitakuZaikoUpdated)) {
      this.zaitakuZaikoUpdated = result.concat();
    }
    return result;
  }

  compareArray(a, b) {



    return JSON.stringify(a) === JSON.stringify(b)
  }


  isEmpty(obj) {
    if (obj == undefined) return true;
    return !Object.keys(obj).length;
  }


  shiborikomi(clinics, member) {

    if (this.shiborikomiWord.length == 0) return true;


    const clinicName = this.getClinicName(clinics, member.clinic_id);


    if ((clinicName + member.name).indexOf(this.shiborikomiWord) != -1) {

      return true;
    } else {
      return false;
    }

  }

  setComfiredBadge() {
    const value = "確定処理を実行します。よろしいですか？(確定マークが表示されます)"
    this.alertViewService.showYesNoAlertComfirmed(value).then((ret) => {
      if (ret) {
        var docRef = this.db.firestore.collection('patients').doc(this.patient_id).collection('events').doc(this.form.value.id);
        docRef.update({
          finalComfirmed: true
        }).then(() => {
        });

      }
    })


  }


  onSubmit(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.clinics.pipe(first()).subscribe((clinics) => {
      this.form.value.event_color = clinics.find((clinic) => {
        return clinic.id === this.form.value.clinicId;
      }).event_color;

      this.form.value["処置内容"] = this.arrays.処置内容.concat();
      this.form.value["実施物品"] = this.arrays.実施物品.concat();
      this.form.value["持ち込み物品"] = this.arrays.持ち込み物品.concat();

      var eventList = [];
      var startTime = new Date(this.form.value.startTime);
      var endTime = new Date(this.form.value.endTime);

      var optionalInputsForRepeat = { ...this.form.value }
      optionalInputsForRepeat.処置内容 = [];
      optionalInputsForRepeat.実施物品 = [];
      optionalInputsForRepeat.持ち込み物品 = [];
      optionalInputsForRepeat.blood_pressure_high = "";
      optionalInputsForRepeat.blood_pressure_low = "";
      optionalInputsForRepeat.pulse = "";
      optionalInputsForRepeat.SPO2 = "";
      optionalInputsForRepeat.Temp = "";
      optionalInputsForRepeat.Weight = "";
      optionalInputsForRepeat.description = "";

      if (this.repeatSetting == 0 || this.disableEditRepeatSetting) {
        eventList.push({
          id: this.form.value.id ? this.form.value.id : this.db.createId(),
          repeat_id: this.form.value.repeat_id ? this.form.value.repeat_id : null,
          // repeat_id: null,
          repeat_setting: this.repeatSetting,
          clinicId: this.form.value.clinicId,
          date: startTime.setDate(startTime.getDate() + 0 * 7),
          optionalInputs: this.form.value,
          allDay: true,
          color: this.form.value.event_color
        });

      } else if (this.repeatSetting == 1) {

        for (let i = 0; i < 150; i++) {
          const current = new Date(startTime);

          const newStartDate = new Date(this.form.value.startTime);
          newStartDate.setDate(startTime.getDate() + (i * 7));
          optionalInputsForRepeat.startTime = this.formatDate(newStartDate, 'yyyy-MM-ddTHH:mm');

          const newEndDate = new Date(this.form.value.endTime);
          newEndDate.setDate(endTime.getDate() + (i * 7));
          optionalInputsForRepeat.endTime = optionalInputsForRepeat.endTime.length ? this.formatDate(newEndDate, 'yyyy-MM-ddTHH:mm') : "";

          eventList.push({
            id: this.db.createId(),
            repeat_id: Date.parse(new Date().toString()),
            repeat_setting: this.repeatSetting,
            clinicId: this.form.value.clinicId,
            date: current.setDate(startTime.getDate() + (i * 7)),
            optionalInputs: i == 0 ? this.form.value : Object.assign({}, optionalInputsForRepeat),
            allDay: true,
            color: this.form.value.event_color
          });
        }


      } else if (this.repeatSetting == 2) {

        var addedDays = [];


        for (let i = 0; i < 36; i++) {

          const start = new Date(startTime);
          const month = new Date(start.setMonth(i)).getMonth();
          const year = new Date(start.setMonth(i)).getFullYear();

          if (this.selectedWeekDays[7]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 1, month, year)); } // 月
          if (this.selectedWeekDays[8]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 2, month, year)); } // 火
          if (this.selectedWeekDays[9]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 3, month, year)); } // 水
          if (this.selectedWeekDays[10]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 4, month, year)); } // 木
          if (this.selectedWeekDays[11]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 5, month, year)); } // 金
          if (this.selectedWeekDays[12]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 6, month, year)); } // 土
          if (this.selectedWeekDays[13]) { addedDays = addedDays.concat(this.getSelectedWeekDayByMonth(this.selectedWeekDays, 0, month, year)); } // 日

        }




        addedDays.forEach((day, index) => {

          if (day.getTime() > (new Date).setHours(0, 0, 0, 0)) {

            const newStartDate = new Date(this.form.value.startTime);
            day.setHours(newStartDate.getHours());
            day.setMinutes(newStartDate.getMinutes());
            optionalInputsForRepeat.startTime = this.formatDate(day, 'yyyy-MM-ddTHH:mm');

            if (this.form.value.endTime.length > 0) {


              const newEndDate = new Date(this.form.value.endTime);
              day.setHours(newEndDate.getHours());
              day.setMinutes(newEndDate.getMinutes());
              optionalInputsForRepeat.endTime = optionalInputsForRepeat.endTime.length ? this.formatDate(day, 'yyyy-MM-ddTHH:mm') : "";
            }

            eventList.push({
              id: this.db.createId(),
              repeat_id: Date.parse(new Date().toString()),
              repeat_setting: this.repeatSetting,
              clinicId: this.form.value.clinicId,
              date: day.getTime(),
              optionalInputs: index == 0 ? this.form.value : Object.assign({}, optionalInputsForRepeat),
              allDay: true,
              color: this.form.value.event_color
            });
          }


        });






        // for (let i = 0; i < 36; i++) {
        //   const current = new Date(startTime);

        //   const newStartDate = new Date(this.form.value.startTime);
        //   newStartDate.setMonth(startTime.getMonth() + i);
        //   optionalInputsForRepeat.startTime = this.formatDate(newStartDate, 'yyyy-MM-ddTHH:mm');


        //   const newEndDate = new Date(this.form.value.endTime);
        //   newEndDate.setMonth(endTime.getMonth() + i);
        //   optionalInputsForRepeat.endTime = optionalInputsForRepeat.endTime.length ? this.formatDate(newEndDate, 'yyyy-MM-ddTHH:mm') : "";



        //   eventList.push({
        //     id: this.db.createId(),
        //     repeat_id: Date.parse(this.form.value.startTime),
        //     repeat_setting: this.repeatSetting,
        //     clinicId: this.form.value.clinicId,
        //     date: current.setMonth(startTime.getMonth() + i),
        //     optionalInputs: i == 0 ? this.form.value : Object.assign({}, optionalInputsForRepeat),
        //     allDay: true,
        //     color: this.form.value.event_color
        //   });
        // }


      }


      this.alertViewService.showLoading();

      var batch = this.db.firestore.batch();


      eventList.forEach((doc, index) => {
        var docRef = this.db.firestore.collection('patients').doc(this.patient_id).collection('events').doc(doc.id); //automatically generate unique id
        batch.set(docRef, doc);
        if ((index + 1) % 500 === 0) {
          batch.commit(); //新しいインスタンス

          batch = this.db.firestore.batch(); //新たにインスタンスを生成。
        }
      });

      console.log("commit final");
      batch.commit().then(() => {

        this.alertViewService.notify("訪問予定を追加しました");


        // if (document.getElementById("flexCheckChecked")["checked"]) {
        //   this.patient.pipe(first()).subscribe((patients) => {
        //     this.addComment(null, "test", patients[0]);
        //   })
        // }
        this.eventEditMode = false;
        //this.alertViewService.dismiss();
      });

    });



  }


  onChangeSelect(value) {
    this.selected_areas['実施物品'] = value;
  }

  onChangeSelectClinic(value) {
    this.clinics.pipe(first()).subscribe(clinics => {
      if (this.getClinicName(clinics, value) === "その他") {
        this.showNewClinicAlert(value);
      }
    });


  }



  addItemArray(name) {
    if (this.selected_areas[name] === "フリー入力") {
      if (this.input_areas[name].length) {
        this.arrays[name].push(this.input_areas[name]);
        this.input_areas[name] = "";
      }

    } else {
      if (this.selected_areas[name].length)
        this.arrays[name].push(this.selected_areas[name]);
    }


    //重複削除
    this.arrays[name] = [...new Set(this.arrays[name])];
  }

  addNumItemArray(name) {

    if (name === "実施物品" && (document.getElementById("jisshibuppinn")["value"].length > 0)) {
      this.selected_areas[name] = document.getElementById("jisshibuppinn")["value"];
    }

    if (name === "持ち込み物品" && (document.getElementById("mochikomibuppinn")["value"].length > 0)) {
      this.selected_areas[name] = document.getElementById("mochikomibuppinn")["value"];
    }



    if (this.selected_areas[name] === "フリー入力") {
      if (this.input_areas[name].length) {
        this.arrays[name].push({
          name: this.input_areas[name],
          num: 0
        });


        // Sync To 実施物品
        if (name === "持ち込み物品") {
          if (!(this.arrays["実施物品"].find((item) => {
            return item["name"] === this.selected_areas[name]
          }))) {
            this.arrays["実施物品"].push({
              name: this.input_areas[name],
              num: 0
            });
          }
        }


        this.input_areas[name] = "";
      }
    } else {
      if (this.selected_areas[name].length)
        this.arrays[name].push({
          name: this.selected_areas[name],
          num: 0
        });

      // Sync To 実施物品
      if (name === "持ち込み物品") {
        if (!(this.arrays["実施物品"].find((item) => {
          return item["name"] === this.selected_areas[name]
        }))) {
          this.arrays["実施物品"].push({
            name: this.selected_areas[name],
            num: 0
          });
        }
      }

    }


    //重複削除
    // this.arrays[name] = [...new Set(this.arrays[name])];

    this.arrays[name] = this.arrays[name].filter((thing, index, self) =>
      index === self.findIndex((t) => (
        t.name === thing.name
      ))
    )


  }

  deleteItemArray(name, value) {
    this.arrays[name] = this.arrays[name].filter(n => n !== value);
  }

  deleteNumItemArray(name, value) {
    this.arrays[name] = this.arrays[name].filter(n => n.name !== value);
  }

  shouldShowFavButton(value, listsA, listB) {

    if (listsA == undefined) {
      listsA = []
    } else if (listB == undefined) {
      listB = []
    }


    if (listsA.includes(value) || listB.includes(value)) {
      return false;
    } else {
      return true;
    }
  }



  addFavoriteItem(fieldname: string, index, value, path) {
    if (value) {
      this.alertViewService.showYesNoAlertAdd(value).then((ret) => {
        if (ret) {
          var obj = {};

          obj[`${fieldname}`] = firebase.default.firestore.FieldValue.arrayUnion(value);

          this.db.doc<any>('clinics/' + this.currentUser.clinic_id + '/selections/' + path).set(obj, { merge: true }).then(ret => {
            console.log(ret);
          }).catch(ret => {
            console.log(ret);
          })

        }
      })
    }
  }

  removeEvent() {
    var removingNow = false;
    this.events.pipe(first()).subscribe((events) => {
      if (removingNow) return;

      const event = events.find((event) => {
        return event.id === this.currentEventInfo.event.id;
      });

      this.alertViewService.removeEventAlert("予定の削除", event.repeat_id).then(ret => {
        if (ret) {
          this.db.collection('patients').doc(this.patient_id).collection<Event>('events').doc(this.currentEventInfo.event.id).delete();
          this.closeModal();
        } else {
          removingNow = true;
          // this.deleteCollection(event);
          this.deleteDocWithBatch(event);
          this.closeModal();
        }
      })
    });


  }


  deleteDocWithBatch(event) {
    // First perform the query
    var self = this;
    this.loadingController.create({
      message: '更新中...',
      translucent: true
    }).then((response) => {
      response.present();

      this.db.firestore.collection('patients').doc(this.patient_id).collection('events').where('repeat_id', '==', event.repeat_id).where('date', '>=', event.date).get()
        .then(function (querySnapshot) {
          // Once we get the results, begin a batch
          var batch = self.db.firestore.batch();

          var index = 0;

          querySnapshot.forEach((doc) => {
            // For each doc, add a delete operation to the batch
            batch.delete(doc.ref);
            if ((index + 1) % 500 === 0) {
              batch.commit(); //新しいインスタンス
              batch = self.db.firestore.batch(); //新たにインスタンスを生成。
            }
            index++;
          });

          self.dismissLoader();
          // Commit the batch
          return batch.commit();
        }).then(function () {
          // Delete completed!
          // ...
        });


    });




  }





}
